export const paths = [{ "tag": "path", "att": { "fill-rule": "evenodd", "clip-rule": "evenodd", "d": "M4 4v7h7V4H4zm2 5V6h3v3H6zm7-5v7h7V4h-7zm2 5V6h3v3h-3zM4 13h7v7H4v-7zm2 2v3h3v-3H6zm7-2v7h7v-7h-7zm2 5v-3h3v3h-3z" } }];
export const iconName = 'square-grid-2x2';
export const squareGrid2x2 = { iconName, paths };
export default paths;
